import { Box, Container, Tab, Tabs, Typography } from '@material-ui/core'
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined'
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined'
import { useNavigate, useParams } from 'react-router-dom'

import { useCompanies } from '@/hooks/use-companies'
import { routes } from '@/routes/config'

import { EmptyComponent } from './components/empty-component'
import EconomyDashboard from './economy-dashboard'
import EconomyIndicators from './economy-indicators'
import { Infestation } from './infestation'
import { OperationCosts } from './operation-costs'
import { useStyles } from './styles'

const tabs = {
  'economy-indicators': {
    label: 'Indicadores de economia',
    Icon: MonetizationOnOutlinedIcon,
    Component: EconomyIndicators,
    permission: ['admin', 'owner'],
  },
  'operation-costs': {
    label: 'Custos de operação',
    Icon: () => <span className='material-symbols-outlined'>agriculture</span>,
    Component: OperationCosts,
    permission: ['admin', 'owner'],
  },
  infestation: {
    label: 'Infestação',
    Icon: () => <span className='material-symbols-outlined'>grass</span>,
    Component: Infestation,
    permission: ['admin', 'owner', 'member'],
  },
  'economy-dashboard': {
    label: 'Economia',
    Icon: DashboardOutlinedIcon,
    Component: EconomyDashboard,
    permission: ['admin', 'owner'],
  },
}

export default function Reports() {
  const classes = useStyles()
  const { type } = useParams<{ type: string }>()
  const { role } = useCompanies()
  const navigate = useNavigate()

  const currentTab = tabs[type as keyof typeof tabs]

  const hasPermission = currentTab?.permission.includes(role)

  const CurrentTab = currentTab?.Component

  return (
    <Box className={classes.container}>
      <Box className={classes.aside}>
        <Typography variant='h1'>Relatórios</Typography>
        <Tabs
          orientation='vertical'
          variant='standard'
          className={classes.tabs}
          TabIndicatorProps={{ style: { display: 'none' } }}
          value={currentTab ? type : false}
          onChange={(_, newValue) => navigate(routes.Reports(newValue))}
        >
          {Object.entries(tabs).map(([id, { Icon, ...tab }]) => (
            <Tab
              key={id}
              className={classes.tab}
              label={tab.label}
              value={id}
              icon={<Icon />}
            />
          ))}
        </Tabs>
      </Box>
      <Container className={classes.currentTabContainer}>
        {hasPermission ? (
          <CurrentTab />
        ) : (
          <EmptyComponent
            title='Página com acesso restrito'
            subtitle=' Contate o administrador da sua companhia e solicite que ele altere o
          seu acesso para proprietário ou administrador'
          />
        )}
      </Container>
    </Box>
  )
}
